import SelfIndicationForm from '../../components/SelfIndicationForm';

const Lead = () => (<SelfIndicationForm type='createUser'/>);

export default Lead
